import * as Sentry from '@sentry/react';
import { RewriteFrames } from "@sentry/integrations";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();
const releaseVersion = require('../package.json').version;
const url = `${process.env.REACT_APP_DASHBOARD_API_ROOT}/configuration/`;

export default function fetchSentryDsn(retries=10, wait=60000){

    if (retries < 0) {
        console.warn("Could not fetch sentry config - max retries reached.");
        return;
    }

    if (process.env.REACT_APP_DISABLE_SENTRY === "true") {
        console.log("Local Sentry config disabled.");
        return;
    }

    fetch(url).then(response=>response.json()).then(data=>{
        Sentry.init({
            release: releaseVersion,
            dsn:data.sentry_dsn,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            tracesSampleRate: 0.02,
            integrations: [
                new Sentry.Replay(),
                new RewriteFrames({root: process.cwd()}),
                new Sentry.BrowserTracing({
                    routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
                }),
            ],
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/dashboard-api\.diversio\.com\/dashboardapp/,
                /^https:\/\/staging-dashboard-api\.diversio\.com\/dashboardapp/
            ],
            ignoreErrors: [
                'ResizeObserver loop completed with undelivered notifications.',
                'ResizeObserver loop limit exceeded',
                'TypeError: Failed to fetch',
                'TypeError: NetworkError when attempting to fetch resource.',
                'Event `Event` (type=unhandledrejection) captured as promise rejection',
                'Non-Error promise rejection captured'
            ],
            beforeSend: event => {
                // filter out UnhandledRejection errors that have no information
                if (event !== undefined && event.exception !== undefined && event.exception.values !== undefined
                    && event.exception.values.length == 1) {
                    var e = event.exception.values[0];
                    if (e.mechanism?.type === "onunhandledrejection") {
                        return null;
                    }
                }
            }
        });
    }).catch(e=>{
        console.warn(`Could not fetch sentry config, trying again in ${wait/60000} min...`);
        setTimeout(() => fetchSentryDsn(retries=retries-1, wait=wait*2), wait);
    });
}
